export interface NavItem {
  path: string
  icon: string
  titleId: string
  betaOnly?: boolean
}

export const navItems: NavItem[] = [
  {
    path: '/',
    icon: 'home-filled',
    titleId: 'nav.home'
  },
  // {
  //   path: '/data-sets',
  //   icon: 'pile-filled',
  //   titleId: 'nav.data-sets'
  // },
  {
    path: '/queries',
    icon: 'code-filled',
    titleId: 'nav.queries'
  },
  {
    path: '/dashboards',
    icon: 'dashboard-filled',
    titleId: 'nav.dashboards'
  },
  {
    path: '/explore',
    icon: 'global',
    titleId: 'nav.explore'
  },
  {
    path: '/favorites',
    icon: 'star-filled',
    titleId: 'nav.favorites',
    betaOnly: true
  },
  {
    path: '/profile',
    icon: 'profile',
    titleId: 'nav.profile'
  },
  {
    path: '/pricing',
    icon: 'pricing',
    titleId: 'nav.pricing'
  }
]

export function getValidParentRoutes(): string[] {
  return navItems.map((item) => item.path)
}
